import { render } from "./CivilStatus.vue?vue&type=template&id=4dde7b10&scoped=true"
import script from "./CivilStatus.vue?vue&type=script&lang=js"
export * from "./CivilStatus.vue?vue&type=script&lang=js"

import "./CivilStatus.vue?vue&type=style&index=0&id=4dde7b10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dde7b10"]])

export default __exports__